import {
    HeroBg,
    HeroContainer,
    HeroContent,
    HeroH1, HeroH2, HeroH3,
    HeroP,
} from './HeroSectionElements';
import Video from '../../videos/Tax-File-App-Features.mp4'

const HeroSection = () => {

    return (
        <>
            <HeroContainer>
                <HeroContent>
                    <HeroH1>File 1099 & W2 </HeroH1>
                    <HeroH2>$1.75 Only</HeroH2>
                    <HeroH3>Effortless 1099 & W2 E-filing, Save Time & Money with Our User-Friendly Dashboard</HeroH3>
                    <HeroP>
                        No Minimums, No Hidden Fees, No Subscriptions
                    </HeroP>
                    <HeroP>
                        Support Last Two Years Filing
                    </HeroP>
                </HeroContent>
                <HeroBg>
                    <video
                        controls
                        autoPlay
                        muted
                    >
                        <source src={Video}  type="video/mp4"/>
                    </video>
                </HeroBg>
            </HeroContainer>
        </>
    )
}

export default HeroSection;
